document.addEventListener("DOMContentLoaded", code);
if(window.acf) {
	window.acf.addAction('render_block_preview/type=brand-logo-slider', code);
}

function code(event) {
	
}